import CityPageTemplate from "../city-template/CityPageTemplate";
import { paducahConfig } from "./data";

export default function PaducahPage() {
  return <CityPageTemplate config={paducahConfig} />;
}